import { container } from "tsyringe";
export class Services {
    constructor(container, options) {
        this.container = container;
        this.options = options;
    }
    getService(token) {
        return this.container.resolve(token);
    }
}
const services = window?.qbo4?.services || new Services(container.createChildContainer(), {});
// Expose tsyring.container as qbo4.Logging.Services, but ensure it's global.
if (typeof window !== 'undefined') {
    window.qbo4 = window.qbo4 || {};
    window.qbo4.services = window.qbo4.services || new Services(container.createChildContainer(), {});
    const services = window.qbo4.services;
}
export { services };
